import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Home from '../components/views/Home';

import actions from '../store/appActions';

const mapStateToProps = state => {
  const { north, east, south, west, start, end } = state.query || {};
  const isFiniteNumber = value =>
    typeof value === 'number' && Number.isFinite(value);
  const layerNames = Array.isArray(state.layer && state.layer.layers)
    ? state.layer.layers
        .map(layer => layer && layer.name)
        .filter(name => typeof name === 'string' && name.trim() !== '')
    : [];
  return {
    mapBoundsReady:
      isFiniteNumber(north) &&
      isFiniteNumber(east) &&
      isFiniteNumber(south) &&
      isFiniteNumber(west),
    timelineTotal: state.timeline?.total || 0,
    querySearch: state.query?.searchQuery || '',
    queryMode: state.query?.mode,
    queryConcepts: state.query?.concepts || [],
    queryDataSources: state.query?.dataSources || [],
    queryAgents: state.query?.agents || [],
    queryAreas: state.query?.areas || [],
    queryNorth: north,
    queryEast: east,
    querySouth: south,
    queryWest: west,
    queryStart: start,
    queryEnd: end,
    mapLayerNames: layerNames
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAggregates: actions.timeline.getAggregates,
      getTimeline: actions.timeline.getTimeline,
      getAlertTimeline: actions.timeline.getAlertTimeline,
      syncAlertsFromTimelineResults:
        actions.timeline.syncAlertsFromTimelineResults,
      setScrollToTop: actions.timeline.setScrollToTop,
      getAllLayerFeatures: actions.user.getAllLayerFeatures,
      setLastKnownUpdate: actions.user.setLastKnownUpdate,
      clearCommonLayerFeatures: actions.user.clearCommonLayerFeatures,
      clearEntireTrack: actions.layer.clearEntireTrack,
      getAlertLayerFeature: actions.user.getAlertLayerFeature,
      getAgentLayerFeatures: actions.user.getAgentLayerFeatures,
      getConceptsCount: actions.ontology.getConceptsCount,
      clearConceptsCount: actions.ontology.clearConceptsCount,
      getDataSources: actions.timeline.getDataSources,
      getAgents: actions.timeline.getAgents,
      clearTimelineResults: actions.timeline.clearTimelineResults,
      clearTimelineFacets: actions.timeline.clearTimelineFacets,
      getFilterTreeList: actions.ontology.getFilterTreeList,
      getLabels: actions.ontology.getLabels,
      setSelectedConcepts: actions.query.setSelectedConcepts,
      setSelectedDataSources: actions.query.setSelectedDataSources,
      setSelectedAgents: actions.query.setSelectedAgents,
      setSearchQuery: actions.query.setSearchQuery,
      setStartEnd: actions.query.setStartEnd,
      setMode: actions.query.setMode,
      setSelectedLayers: actions.layer.setSelectedLayers,
      clearSelectedItem: actions.timeline.clearSelectedItem
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Home);
